import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

export default function TextScramble({ text, className = '', as: Tag = 'h1', delay = 0 }) {
  const containerRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || hasAnimated) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            const chars = el.querySelectorAll('.scramble-char');
            gsap.fromTo(chars,
              { opacity: 0, y: 20 },
              {
                opacity: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.03,
                delay,
                ease: 'power3.out'
              }
            );
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasAnimated, delay]);

  const words = text.split(' ');

  return (
    <Tag ref={containerRef} className={className} style={{ fontFamily: 'Cormorant Garamond, serif' }}>
      {words.map((word, wi) => (
        <span key={wi} className="inline-block whitespace-nowrap">
          {word.split('').map((char, ci) => (
            <span key={ci} className="scramble-char inline-block">
              {char}
            </span>
          ))}
          {wi < words.length - 1 && <span className="scramble-char inline-block">&nbsp;</span>}
        </span>
      ))}
    </Tag>
  );
}
